class PolicyAmendmentPetitionDetail {
    constructor(
        id,
        type,
        cancellationForm,
        paymentChangesForm,
        policyChangesForm,
        status,
        petitionNumber,
        createdAt,
        statusLog
    ) {
        this.id = id
        this.type = type
        this.cancellationForm = cancellationForm
        this.paymentChangesForm = paymentChangesForm
        this.policyChangesForm = policyChangesForm
        this.status = status
        this.petitionNumber = petitionNumber
        this.createdAt = createdAt
        this.statusLog = statusLog
    }

    static fromJson({
        id,
        type,
        cancellationForm,
        paymentChangesForm,
        policyChangesForm,
        status,
        petitionNumber,
        createdAt,
        statusLog,
    }) {
        return new PolicyAmendmentPetitionDetail(
            id,
            type,
            cancellationForm,
            paymentChangesForm,
            policyChangesForm,
            status,
            petitionNumber,
            createdAt,
            statusLog
        )
    }
}

export default PolicyAmendmentPetitionDetail
